/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Toast_Injection_FailedInputs */

const en_keyword_optimizer_toast_injection_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Injection_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestion generation failed`)
};

const de_keyword_optimizer_toast_injection_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Injection_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschlagserstellung fehlgeschlagen`)
};

const fr_keyword_optimizer_toast_injection_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Injection_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la génération des suggestions`)
};

const es_keyword_optimizer_toast_injection_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Injection_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al generar sugerencias`)
};

const it_keyword_optimizer_toast_injection_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Injection_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generazione suggerimenti fallita`)
};

const nl_keyword_optimizer_toast_injection_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Injection_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggesties genereren mislukt`)
};

const pl_keyword_optimizer_toast_injection_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Injection_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generowanie sugestii nie powiodło się`)
};

const fi_keyword_optimizer_toast_injection_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Injection_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ehdotusten luonti epäonnistui`)
};

const da_keyword_optimizer_toast_injection_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Injection_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forslagsgenerering mislykkedes`)
};

const sv_keyword_optimizer_toast_injection_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Injection_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Förslagsgenerering misslyckades`)
};

/**
* | output |
* | --- |
* | "Suggestion generation failed" |
*
* @param {Keyword_Optimizer_Toast_Injection_FailedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_toast_injection_failed = /** @type {((inputs?: Keyword_Optimizer_Toast_Injection_FailedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Toast_Injection_FailedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_toast_injection_failed(inputs)
	if (locale === "fr") return fr_keyword_optimizer_toast_injection_failed(inputs)
	if (locale === "es") return es_keyword_optimizer_toast_injection_failed(inputs)
	if (locale === "it") return it_keyword_optimizer_toast_injection_failed(inputs)
	if (locale === "nl") return nl_keyword_optimizer_toast_injection_failed(inputs)
	if (locale === "pl") return pl_keyword_optimizer_toast_injection_failed(inputs)
	if (locale === "fi") return fi_keyword_optimizer_toast_injection_failed(inputs)
	if (locale === "da") return da_keyword_optimizer_toast_injection_failed(inputs)
	if (locale === "sv") return sv_keyword_optimizer_toast_injection_failed(inputs)
	return en_keyword_optimizer_toast_injection_failed(inputs)
});